export class CostReviewElectricalEquipment {
  toolsAndTestEquipmentRequired!: number;
  equipmentRentalEtcEstimated!: number;
  specialEquipmentRequired!: number;
  specialEquipmentList!: number[];
  responsibleForProviding!: number;
}
